/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfGenerateSchedulePeriodsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfGetHangfireJobResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewDepartmentDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewDepartmentDto } from '../api-models';
// @ts-ignore
import { GenerateSchedulePeriodsRequest } from '../api-models';
// @ts-ignore
import { GetHangfireJobRequest } from '../api-models';
// @ts-ignore
import { UpdateLaborLevelExtensionDto } from '../api-models';
// @ts-ignore
import { ViewSchedulePeriodDto } from '../api-models';
/**
 * DepartmentApi - axios parameter creator
 * @export
 */
export const DepartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentBuildSchedulesPost: async (schedulePeriodId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department/build-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDeleteLegacySchedulesGet: async (departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department/delete-legacy-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {GetHangfireJobRequest} [getHangfireJobRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDepartmentIdJobsPost: async (departmentId: number, getHangfireJobRequest?: GetHangfireJobRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentDepartmentIdJobsPost', 'departmentId', departmentId)
            const localVarPath = `/Department/{departmentId}/jobs`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHangfireJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDepartmentIdSchedulePeriodOffsetsPut: async (departmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentDepartmentIdSchedulePeriodOffsetsPut', 'departmentId', departmentId)
            const localVarPath = `/Department/{departmentId}/schedule-period-offsets`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentGet: async (facilityId?: number, filteredByOpeningTemplates?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (filteredByOpeningTemplates !== undefined) {
                localVarQueryParameter['filteredByOpeningTemplates'] = filteredByOpeningTemplates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentIdGet: async (id: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentIdGet', 'id', id)
            const localVarPath = `/Department/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateLaborLevelExtensionDto} [updateLaborLevelExtensionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentIdPut: async (id: number, updateLaborLevelExtensionDto?: UpdateLaborLevelExtensionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentIdPut', 'id', id)
            const localVarPath = `/Department/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLaborLevelExtensionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {boolean} [onlyBuiltPeriods] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentSchedulePeriodsGet: async (departmentId?: number, facilityId?: number, onlyBuiltPeriods?: boolean, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department/schedule-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (onlyBuiltPeriods !== undefined) {
                localVarQueryParameter['onlyBuiltPeriods'] = onlyBuiltPeriods;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateSchedulePeriodsRequest} [generateSchedulePeriodsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentSchedulePeriodsPost: async (generateSchedulePeriodsRequest?: GenerateSchedulePeriodsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department/schedule-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSchedulePeriodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {boolean} [forBuildSchedules] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentV2SchedulePeriodsGet: async (departmentId?: number, facilityId?: number, forBuildSchedules?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Department/v2/schedule-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (forBuildSchedules !== undefined) {
                localVarQueryParameter['forBuildSchedules'] = forBuildSchedules;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentApi - functional programming interface
 * @export
 */
export const DepartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentBuildSchedulesPost(schedulePeriodId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentBuildSchedulesPost(schedulePeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentDeleteLegacySchedulesGet(departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentDeleteLegacySchedulesGet(departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {GetHangfireJobRequest} [getHangfireJobRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentDepartmentIdJobsPost(departmentId: number, getHangfireJobRequest?: GetHangfireJobRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfGetHangfireJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentDepartmentIdJobsPost(departmentId, getHangfireJobRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentDepartmentIdSchedulePeriodOffsetsPut(departmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentDepartmentIdSchedulePeriodOffsetsPut(departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentGet(facilityId?: number, filteredByOpeningTemplates?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewDepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentGet(facilityId, filteredByOpeningTemplates, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentIdGet(id: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewDepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentIdGet(id, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateLaborLevelExtensionDto} [updateLaborLevelExtensionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentIdPut(id: number, updateLaborLevelExtensionDto?: UpdateLaborLevelExtensionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentIdPut(id, updateLaborLevelExtensionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {boolean} [onlyBuiltPeriods] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentSchedulePeriodsGet(departmentId?: number, facilityId?: number, onlyBuiltPeriods?: boolean, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewSchedulePeriodDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentSchedulePeriodsGet(departmentId, facilityId, onlyBuiltPeriods, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GenerateSchedulePeriodsRequest} [generateSchedulePeriodsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentSchedulePeriodsPost(generateSchedulePeriodsRequest?: GenerateSchedulePeriodsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfGenerateSchedulePeriodsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentSchedulePeriodsPost(generateSchedulePeriodsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {boolean} [forBuildSchedules] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentV2SchedulePeriodsGet(departmentId?: number, facilityId?: number, forBuildSchedules?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewSchedulePeriodDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentV2SchedulePeriodsGet(departmentId, facilityId, forBuildSchedules, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentApi - factory interface
 * @export
 */
export const DepartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentApiFp(configuration)
    return {
        /**
         * 
         * @param {DepartmentApiDepartmentBuildSchedulesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentBuildSchedulesPost(requestParameters: DepartmentApiDepartmentBuildSchedulesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentBuildSchedulesPost(requestParameters.schedulePeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentDeleteLegacySchedulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDeleteLegacySchedulesGet(requestParameters: DepartmentApiDepartmentDeleteLegacySchedulesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentDeleteLegacySchedulesGet(requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentDepartmentIdJobsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDepartmentIdJobsPost(requestParameters: DepartmentApiDepartmentDepartmentIdJobsPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfGetHangfireJobResponse> {
            return localVarFp.departmentDepartmentIdJobsPost(requestParameters.departmentId, requestParameters.getHangfireJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentDepartmentIdSchedulePeriodOffsetsPut(requestParameters: DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentDepartmentIdSchedulePeriodOffsetsPut(requestParameters.departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentGet(requestParameters: DepartmentApiDepartmentGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewDepartmentDto> {
            return localVarFp.departmentGet(requestParameters.facilityId, requestParameters.filteredByOpeningTemplates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentIdGet(requestParameters: DepartmentApiDepartmentIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewDepartmentDto> {
            return localVarFp.departmentIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentIdPut(requestParameters: DepartmentApiDepartmentIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.departmentIdPut(requestParameters.id, requestParameters.updateLaborLevelExtensionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentSchedulePeriodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentSchedulePeriodsGet(requestParameters: DepartmentApiDepartmentSchedulePeriodsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewSchedulePeriodDto>> {
            return localVarFp.departmentSchedulePeriodsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.onlyBuiltPeriods, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentSchedulePeriodsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentSchedulePeriodsPost(requestParameters: DepartmentApiDepartmentSchedulePeriodsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfGenerateSchedulePeriodsResponse> {
            return localVarFp.departmentSchedulePeriodsPost(requestParameters.generateSchedulePeriodsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentApiDepartmentV2SchedulePeriodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentV2SchedulePeriodsGet(requestParameters: DepartmentApiDepartmentV2SchedulePeriodsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewSchedulePeriodDto>> {
            return localVarFp.departmentV2SchedulePeriodsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.forBuildSchedules, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for departmentBuildSchedulesPost operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentBuildSchedulesPostRequest
 */
export interface DepartmentApiDepartmentBuildSchedulesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentBuildSchedulesPost
     */
    readonly schedulePeriodId?: number
}

/**
 * Request parameters for departmentDeleteLegacySchedulesGet operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentDeleteLegacySchedulesGetRequest
 */
export interface DepartmentApiDepartmentDeleteLegacySchedulesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentDeleteLegacySchedulesGet
     */
    readonly departmentId?: number
}

/**
 * Request parameters for departmentDepartmentIdJobsPost operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentDepartmentIdJobsPostRequest
 */
export interface DepartmentApiDepartmentDepartmentIdJobsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentDepartmentIdJobsPost
     */
    readonly departmentId: number

    /**
     * 
     * @type {GetHangfireJobRequest}
     * @memberof DepartmentApiDepartmentDepartmentIdJobsPost
     */
    readonly getHangfireJobRequest?: GetHangfireJobRequest
}

/**
 * Request parameters for departmentDepartmentIdSchedulePeriodOffsetsPut operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest
 */
export interface DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPut
     */
    readonly departmentId: number
}

/**
 * Request parameters for departmentGet operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentGetRequest
 */
export interface DepartmentApiDepartmentGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {boolean}
     * @memberof DepartmentApiDepartmentGet
     */
    readonly filteredByOpeningTemplates?: boolean
}

/**
 * Request parameters for departmentIdGet operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentIdGetRequest
 */
export interface DepartmentApiDepartmentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentIdGet
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentIdGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for departmentIdPut operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentIdPutRequest
 */
export interface DepartmentApiDepartmentIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateLaborLevelExtensionDto}
     * @memberof DepartmentApiDepartmentIdPut
     */
    readonly updateLaborLevelExtensionDto?: UpdateLaborLevelExtensionDto
}

/**
 * Request parameters for departmentSchedulePeriodsGet operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentSchedulePeriodsGetRequest
 */
export interface DepartmentApiDepartmentSchedulePeriodsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentSchedulePeriodsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentSchedulePeriodsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {boolean}
     * @memberof DepartmentApiDepartmentSchedulePeriodsGet
     */
    readonly onlyBuiltPeriods?: boolean

    /**
     * 
     * @type {string}
     * @memberof DepartmentApiDepartmentSchedulePeriodsGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for departmentSchedulePeriodsPost operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentSchedulePeriodsPostRequest
 */
export interface DepartmentApiDepartmentSchedulePeriodsPostRequest {
    /**
     * 
     * @type {GenerateSchedulePeriodsRequest}
     * @memberof DepartmentApiDepartmentSchedulePeriodsPost
     */
    readonly generateSchedulePeriodsRequest?: GenerateSchedulePeriodsRequest
}

/**
 * Request parameters for departmentV2SchedulePeriodsGet operation in DepartmentApi.
 * @export
 * @interface DepartmentApiDepartmentV2SchedulePeriodsGetRequest
 */
export interface DepartmentApiDepartmentV2SchedulePeriodsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentV2SchedulePeriodsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DepartmentApiDepartmentV2SchedulePeriodsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {boolean}
     * @memberof DepartmentApiDepartmentV2SchedulePeriodsGet
     */
    readonly forBuildSchedules?: boolean
}

/**
 * DepartmentApi - object-oriented interface
 * @export
 * @class DepartmentApi
 * @extends {BaseAPI}
 */
export class DepartmentApi extends BaseAPI {
    /**
     * 
     * @param {DepartmentApiDepartmentBuildSchedulesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentBuildSchedulesPost(requestParameters: DepartmentApiDepartmentBuildSchedulesPostRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentBuildSchedulesPost(requestParameters.schedulePeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentDeleteLegacySchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentDeleteLegacySchedulesGet(requestParameters: DepartmentApiDepartmentDeleteLegacySchedulesGetRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentDeleteLegacySchedulesGet(requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentDepartmentIdJobsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentDepartmentIdJobsPost(requestParameters: DepartmentApiDepartmentDepartmentIdJobsPostRequest, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentDepartmentIdJobsPost(requestParameters.departmentId, requestParameters.getHangfireJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentDepartmentIdSchedulePeriodOffsetsPut(requestParameters: DepartmentApiDepartmentDepartmentIdSchedulePeriodOffsetsPutRequest, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentDepartmentIdSchedulePeriodOffsetsPut(requestParameters.departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentGet(requestParameters: DepartmentApiDepartmentGetRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentGet(requestParameters.facilityId, requestParameters.filteredByOpeningTemplates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentIdGet(requestParameters: DepartmentApiDepartmentIdGetRequest, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentIdPut(requestParameters: DepartmentApiDepartmentIdPutRequest, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentIdPut(requestParameters.id, requestParameters.updateLaborLevelExtensionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentSchedulePeriodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentSchedulePeriodsGet(requestParameters: DepartmentApiDepartmentSchedulePeriodsGetRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentSchedulePeriodsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.onlyBuiltPeriods, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentSchedulePeriodsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentSchedulePeriodsPost(requestParameters: DepartmentApiDepartmentSchedulePeriodsPostRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentSchedulePeriodsPost(requestParameters.generateSchedulePeriodsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentApiDepartmentV2SchedulePeriodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentV2SchedulePeriodsGet(requestParameters: DepartmentApiDepartmentV2SchedulePeriodsGetRequest = {}, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentV2SchedulePeriodsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.forBuildSchedules, options).then((request) => request(this.axios, this.basePath));
    }
}
